import React, { ReactNode, useEffect, useState,useContext } from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { auth } from '../firebase/config';
import { isUserAdmin } from '../firebase/utils';
import { Routes } from 'common/enums';
import { LoadScreen } from 'common/components';
import { appContext } from 'common/contexts/appContext';
interface AdminRouteProps extends Omit<RouteProps, 'render'> {
  children: ReactNode;
}

const AdminRoute = ({ children, ...rest }: AdminRouteProps) => {
  const [loading, setLoading] = useState(true);

  const context = useContext(appContext);
  const isAdmin = context?.state?.isAdmin || false;


  // if (loading) {
  //   return <LoadScreen />;
  // }

  return (
    <Route
      {...rest}
      render={({ location }) =>
        auth.currentUser ? (
          isAdmin ? (
            children
          ) : (
            <Redirect
              to={{
                pathname: Routes.Terminal,
                state: { from: location, error: 'Acceso denegado: Se requiere rol de administrador' }
              }}
            />
          )
        ) : (
          <Redirect
            to={{
              pathname: Routes.SignIn,
              state: { from: location }
            }}
          />
        )
      }
    />
  );
};

export default AdminRoute;
